const $ = jQuery.noConflict();

'use strict';
const AcfForm = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		/** @description functions */
		this.submit();
	},

	// setup "submit" handler for form
	submit: function() {
		const $btn = $('form#acf-form-customer :submit');
		const $form = $('form#acf-form-customer');
		const $formDiv = $('.woocommerce-MyAccount-content.customer');

		$btn.on('click', function(event) {
			event.preventDefault();
			$formDiv.addClass('updating');
			const formData = window.acf.serialize($form);
			formData.action = 'acf/validate_save_post';
			$.post(ajaxurl, formData)
			.done(function(data) {
				// remove old message
				$('.updated-post-info').remove();
				$formDiv.removeClass('updating');
				// create new message
				const NewMessage = data.substring(1, 50).search(/validation/i) === -1
					? '<div class="updated-post-info">Customer data successfully updated</div>'
					: '<div class="updated-post-info error">' + data + '</div>';
				$(NewMessage).prependTo($('.acf-form-submit'));
			});
		});
	}
};

export default AcfForm;
